export const mushroomDead = new Image();
mushroomDead.src = "assets/characterSprites/mushroom/Death.png";
mushroomDead.width = 1200/8;
mushroomDead.height = 150/1;
mushroomDead.yOffset = 40;
mushroomDead.xOffset = 150;
mushroomDead.cycleLoop = [0,1,2,3,4,5,6,7];